export const BrandingData = {

    version: "1.0.0",
    bussinessDomain: "Garage",

    siteName: "Spark",
    poweredBy: "iClicks",
    titleSuffix: " | iClicks - Admin Portal",
    domain: "spark.backoffice.com",
    images: {
        logoLightPath: "assets/images/iclicks-high-resolution-logo-white-transparent.png",
        logoDarkPath: "assets/images/iclicks-high-resolution-logo-transparent.png",
    },

    messageDisplayTimeout: 3000


};